<template>
    <div class="Loader animate-spin">
        <i class="fas fa-spinner"></i>
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
